__turbopack_context__.v({
  "blocksBackgroundColor": "MobileNavFooter-module-scss-module__AZrIXq__blocksBackgroundColor",
  "blocksFontColor": "MobileNavFooter-module-scss-module__AZrIXq__blocksFontColor",
  "container": "MobileNavFooter-module-scss-module__AZrIXq__container",
  "containerHidden": "MobileNavFooter-module-scss-module__AZrIXq__containerHidden",
  "listItem": "MobileNavFooter-module-scss-module__AZrIXq__listItem",
  "menuButton": "MobileNavFooter-module-scss-module__AZrIXq__menuButton",
  "menuItemName": "MobileNavFooter-module-scss-module__AZrIXq__menuItemName",
  "notifications": "MobileNavFooter-module-scss-module__AZrIXq__notifications",
  "secondaryNavBackgroundColor": "MobileNavFooter-module-scss-module__AZrIXq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "MobileNavFooter-module-scss-module__AZrIXq__themeBackgroundColor",
  "themeFontColor": "MobileNavFooter-module-scss-module__AZrIXq__themeFontColor",
  "unorderedList": "MobileNavFooter-module-scss-module__AZrIXq__unorderedList",
});
